/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Button
} from "reactstrap";
//firebase
import firebase from 'firebase'
// redux
import { useDispatch, useSelector } from 'react-redux'
// react library for routing
import { useHistory } from "react-router-dom";

// core components
import AuthHeader from "components/Headers/AuthHeader.js";

// User actions
import { setUserData } from 'actions/userActions'
// actions
import { clearChecklists } from 'actions/checklistActions';
import { clearFilters } from 'actions/filterActions';

function Login() {
  const dispatch = useDispatch();
  const history = useHistory();
  const userState = useSelector(state => state.user);

  React.useEffect(() => {
    const userRefreshInterval = setInterval(async () => {
      const token = await firebase.auth().currentUser.getIdTokenResult(true)
      if (token.claims.role) {
        dispatch(setUserData({
          ...userState.user,
          role: token.claims.role,
          franchises: token.claims.franchises,
          plan: 'free',
        }))
        return history.push('/admin/dashboard');
      }
    }, 5 * 1000)
    return () => clearInterval(userRefreshInterval);
  }, [])

  const logOut = async () => {
    dispatch(clearChecklists());
    dispatch(clearFilters());
    await firebase.auth().signOut()
    history.push('/')
  }

  return (
    <>
      <AuthHeader
        title="Welcome!"
      />
      <Container className="mt--8 pb-5">
        <Row className="justify-content-center">
          <Col lg="5" md="7">
            <Card className="bg-secondary border-0 mb-0">
              <CardHeader className="bg-transparent pb-5">
                <div className="text-muted text-center mt-2 mb-3">
                  <h3>We are working on setting up your account and creating the information for your location.</h3>
                </div>
              </CardHeader>
              <CardBody className="px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <p>If one of our representatives has not given you access, or if they have and you have seen this page for over one minute, please contact us so that we can figure this out for you.</p>
                </div>
                <Row
                  className="justify-content-center"
                  style={{ marginTop: "-0.6rem" }}
                >
                  <Col xs="6">
                    <Button
                      className="mt-4"
                      color="info"
                      type="button"
                      onClick={logOut}
                    >
                      Back to Login
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Login;
